(() => {
 'use strict';
 const allowed=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','gclid','wbraid','gbraid'];
 const incoming=new URLSearchParams(location.search);
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 // Silent inline loops: play only near the viewport, never with player UI or sound, resume after tab switch/back navigation.
 const videos=new Set(),state=new WeakMap(),firstFrame=['loadeddata','suspend','stalled','error'];
 const wanted=video=>{const s=state.get(video);return !!s&&s.near&&!document.hidden&&(!reduced.matches||s.chosen);};
 function play(video){
   const s=state.get(video);
   if(!wanted(video)||!video.paused||s.pending)return;
   // A video that is already buffering starts on its first frame, so Safari keeps the poster instead of an empty frame.
   if(video.readyState<2&&video.networkState===2&&!s.waited){
     s.pending=s.waited=true;
     const go=()=>{firstFrame.forEach(type=>video.removeEventListener(type,go));s.pending=false;play(video);};
     firstFrame.forEach(type=>video.addEventListener(type,go));
     return;
   }
   const settle=error=>{s.pending=false;s.blocked=error?.name==='NotAllowedError';if(!error&&!wanted(video))video.pause();};
   video.muted=true;s.pending=true;
   try{const request=video.play();if(request&&request.then)request.then(()=>settle(),settle);else settle();}catch(error){settle(error);}
 }
 const sync=video=>{if(wanted(video))play(video);else if(!video.paused)video.pause();};
 const syncAll=()=>videos.forEach(sync);
 const setNear=(video,near)=>{const s=state.get(video);if(!s)return;s.near=near;if(!near)s.chosen=false;sync(video);};
 // Buffer a video about one screen ahead (created first, so its callback runs before the play decision).
 const warm='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{if(isIntersecting&&!reduced.matches){target.preload='auto';warm.unobserve(target);}}),{rootMargin:'100% 0px'}):null;
 const observer=warm&&new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>target.isConnected?setNear(target,isIntersecting):forget(target)),{rootMargin:'150px 0px'});
 let frame=0;
 const measure=()=>{frame=0;videos.forEach(video=>{const r=video.getBoundingClientRect();setNear(video,r.width>0&&r.bottom>-150&&r.top<innerHeight+150);});};
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(measure);};
 function forget(video){
   if(!state.has(video))return;
   observer?.unobserve(video);warm?.unobserve(video);videos.delete(video);state.delete(video);video.pause();
 }
 function track(video){
   if(state.has(video))return;
   state.set(video,{near:false,chosen:false,pending:false,blocked:false});videos.add(video);
   video.muted=true;video.defaultMuted=true;video.loop=true;video.playsInline=true;video.controls=false;video.disablePictureInPicture=true;video.disableRemotePlayback=true;
   if(observer){observer.observe(video);warm.observe(video);}else schedule();
 }
 function init(root){
   root.querySelectorAll('a[data-pdp]').forEach(link=>{
     const target=new URL(link.href,location.href);
     if(target.origin!==location.origin)return;
     allowed.forEach(key=>{const value=incoming.get(key);if(value&&!target.searchParams.has(key))target.searchParams.set(key,value);});
     link.href=target.href;
   });
   root.querySelectorAll('[data-noom-video] video').forEach(track);
 }
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('video').forEach(forget));
 if(!observer){addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);}
 document.addEventListener('visibilitychange',syncAll);
 document.addEventListener('resume',syncAll);
 addEventListener('pageshow',syncAll);
 document.addEventListener('ended',event=>{if(wanted(event.target)){event.target.currentTime=0;play(event.target);}},true);
 // Autoplay refused (e.g. battery saving): the next tap or key press starts the videos that should be playing; no timed retries.
 const unlock=()=>videos.forEach(video=>{if(state.get(video).blocked)play(video);});
 ['pointerup','touchend','click','keydown'].forEach(type=>document.addEventListener(type,unlock,{capture:true,passive:true}));
 // Reduced motion: nothing moves by itself; a tap on a video starts or stops it.
 document.addEventListener('click',event=>{
   const video=reduced.matches?event.target.closest?.('[data-noom-video]')?.querySelector('video'):null,s=video&&state.get(video);
   if(s){s.chosen=video.paused;sync(video);}
 });
 if(reduced.addEventListener)reduced.addEventListener('change',syncAll);else reduced.addListener(syncAll);
})();
